import { render } from "./PrintScreen.vue?vue&type=template&id=373c8cc4&scoped=true&ts=true"
import script from "./PrintScreen.vue?vue&type=script&lang=ts"
export * from "./PrintScreen.vue?vue&type=script&lang=ts"

import "./PrintScreen.vue?vue&type=style&index=0&id=373c8cc4&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373c8cc4"]])

export default __exports__